module.exports = __webpack_public_path__ + "img/4.b54f992e.jpg";